import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Checkbox, Container, Grid, Button, Header, Divider, Form, Menu, Message, Modal } from 'semantic-ui-react';
import { FormSongVersion } from '../forms/FormSongVersion';

import { RuleEntry } from '../common/RuleEntry';

// const defaultVersion = {};
const defaultCloning = false;

const emptyVersion = {
  "arranger": {
      "biography_url": null,
      "birth_date": null,
      "blurb": null,
      "created_at": null,
      "death_date": null,
      "deleted_at": null,
      "email": null,
      "ethnicity": null,
      "first_name": null,
      "gender": null,
      "id": 0,
      "image_url": null,
      "input": null,
      "last_name": null,
      "meta": null,
      "notes": null,
      "updated_at": null,
      "website_url": null
  },
  "id": 0,
  "ranges": [],
  "song_id": 0,
  "text_author_ids": [],
  "text_authors": [],
  "translator_ids": [],
  "translators": [],
  "version_info": {
      "alternate_title": "",
      "arranger_id": 0,
      "audio_urls": null,
      "commission": "",
      "composition_end_date": "",
      "composition_start_date": "",
      "created_at": "",
      "dedication": "",
      "deleted_at": null,
      "discography_label": "",
      "duration": 0,
      "duration_display": "00:00:00",
      "id": 0,
      "instrumentation_string": "",
      "languages": [],
      "meta": {},
      "notes": "",
      "pdf_urls": null,
      "premiere_date": null,
      "public_domain_text": false,
      "purchase_urls": null,
      "score_image_urls": null,
      "song_id": 0,
      "text": "",
      "publisher":"",
      "text_publication_date": null,
      "title": "",
      "updated_at": "",
      "version_name": "",
      "voice_type_string": "",
      "is_deleted": null, 
      "vocal_chamber_music": null
  }
};



export const EditSongVersion = ({ openButton, onSuccess, instrumentMap, vtMap, version = null, cloning = defaultCloning, songId = 0, composerId = 0 }) => {
  //console.log("RENDERING: editsongversion");
  const [ creating, setCreating ] = useState();
  const [ data, setData ] = useState({});
  const [ activeTab, setActiveTab ] = useState('General');
  const [ modalOpen, setModalOpen ] = useState(false);
  const [ header, setHeader ] = useState('');

  const [ spinnerActive, setSpinnerActive ] = useState(false);
  const [ loadingMessage, setLoadingMessage ] = useState("");

  const [ arrangerAction, setArrangerAction ] = useState("retain"); // "change", "delete"
  const [ newArrangerProfileId, setNewArrangerProfileId ] = useState(-1);

  const [ newAuthorProfiles, setNewAuthorProfiles ] = useState([]);
  const [ authorProfileIdsToRemove, setAuthorProfileIdsToRemove ] = useState([]);

  const [ newTranslatorProfiles, setNewTranslatorProfiles ] = useState([]);
  const [ translatorProfileIdsToRemove, setTranslatorProfileIdsToRemove ] = useState([]);

  const tabs = [
    { name: 'General', icon: '' },
    { name: 'People', icon: '' },
    { name: 'Links', icon: '' },
    { name: 'Dates', icon: '' },
    //{ name: 'Places', icon: '' },
    //{ name: 'Administrative', icon: ''}
  ];

  const resolveArrangerId = async () => {
    const arrangerSearchResp = await fetch(`/go/api/v1/arrangers/search?q=profile_id:${newArrangerProfileId}`);
    const arrangerSearchJson = await arrangerSearchResp.json();
    if (!arrangerSearchJson.hits || arrangerSearchJson.hits.total === 0) {
      setLoadingMessage("Creating new Arranger record...");
      console.log("creating arranger with id", newArrangerProfileId);
      const newArrResp = await fetch(`/go/api/v1/arrangers`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "ID": 0,
          "ProfileID": newArrangerProfileId
        })
      });
      const newArrJson = await newArrResp.json();
      return newArrJson.ID;
    } else {
      return arrangerSearchJson.hits.hits[0]._source.id;
    }
  };

  const resolveAuthorId = async (profileId) => {
    const authorSearchResp = await fetch(`/go/api/v1/text-authors/search?q=profile_id:${profileId}`);
    const authorSearchJson = await authorSearchResp.json();
    if (!authorSearchJson.hits || authorSearchJson.hits.total === 0 ) {
      setLoadingMessage("Creating new Text Author record...");
      console.log("creating author with pid:", profileId);
      const newAuthorResp = await fetch(`/go/api/v1/text-authors`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "ID": 0,
          "ProfileID": profileId
        })
      });
      const newAuthorJson = await newAuthorResp.json();
      return newAuthorJson.ID;
    } else {
      return authorSearchJson.hits.hits[0]._source.id;
    }
  };

  const resolveTranslatorId = async (profileId) => {
    const xlatorSearchResp = await fetch(`/go/api/v1/translators/search?q=profile_id:${profileId}`);
    const xlatorSearchJson = await xlatorSearchResp.json();
    if (!xlatorSearchJson.hits || xlatorSearchJson.hits.total === 0 ) {
      setLoadingMessage("Creating new Translator record...");
      console.log("creating translators with pid", profileId);
      const newXlatorResp = await fetch(`/go/api/v1/translators`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "ID": 0,
          "ProfileID": profileId
        })
      });
      const newXlatorJson = await newXlatorResp.json();
      return newXlatorJson.ID;
    } else {
      return xlatorSearchJson.hits.hits[0]._source.id;
    }
  };

  const submit = async () => {
    setSpinnerActive(true);
    const message = {};

    let newSongId = 0;

    // create song if needed
    if (songId === 0) {
      const newSongResp = await fetch(`/go/api/v1/songs`, {
        method: "POST",
        body: JSON.stringify({ComposerID: composerId, ID: 0}),
        headers: {
          "Content-type": "application/json"
        }
      });
      if (newSongResp.status !== 200) {
        console.log("problem registering new song record");
      }

      const newSongJson = await newSongResp.json();

      newSongId = newSongJson.ID;
    }

    // Arranger
    if (arrangerAction === "change") {
      setLoadingMessage("Resolving Arranger profile...");
      message.ArrangerID = await resolveArrangerId();
    } else if (arrangerAction === "remove") {
      message.ArrangerID = 0;
    }

    // Text authors
    message.TextAuthors = data.text_author_ids.filter(a => !authorProfileIdsToRemove.includes(a.profile_id)).map(a => { return {ID: a.id}});
    for (const p of newAuthorProfiles) {
      setLoadingMessage("Resolving Text Author profiles...");
      const authorId = await resolveAuthorId(p.id);
      message.TextAuthors.push({ID: authorId});
    }

    // translators
    message.Translators = data.translator_ids.filter(t => !translatorProfileIdsToRemove.includes(t.profile_id)).map(t => {return {ID: t.id}});
    for (const p of newTranslatorProfiles) {
      const xlatorId = await resolveTranslatorId(p.id);
      message.Translators.push({ID: xlatorId});
    }

    message.Ranges = data.ranges.map(r => {
      return {
        High: r.high,
        Low: r.low,
        OssiaHigh: r.ossia_high,
        OssiaLow: r.ossia_low,
        VoiceType: r.voice_type,
        ID: r.id
      };
    });

    message.SongID = songId === 0 ? newSongId : data.version_info.song_id;
    message.Title = data.version_info.title;
    message.AlternateTitle = data.version_info.alternate_title;
    message.Duration = data.version_info.duration;
    message.Text = data.version_info.text;
    message.Publisher = data.version_info.publisher;
    if (data.version_info.composition_start_date !== "") {
      message.CompositionStartDate = data.version_info.composition_start_date;
    }
    if (data.version_info.composition_end_date !== "") {
      message.CompositionEndDate = data.version_info.composition_end_date;
    }
    message.Languages = data.version_info.languages === "" ? [] : data.version_info.languages;
    message.VoiceTypeString = data.version_info.voice_type_string;
    message.InstrumentationString = data.version_info.instrumentation_string;
    message.Duration = data.version_info.duration;
    message.DiscographyLabel = data.version_info.discography_label;
    if (data.version_info.premiere_date !== "") {
      message.PremiereDate = data.version_info.premiere_date;
    }
    message.VersionName = data.version_info.version_name;
    message.Notes = data.version_info.notes;
    message.Commission = data.version_info.commission;
    message.Dedication = data.version_info.dedication;
    message.PurchaseURLs = data.version_info.purchase_urls;
    message.PDFURLs = data.version_info.pdf_urls;
    message.ScoreImageURLs = data.version_info.score_image_urls;
    message.AudioURLs = data.version_info.audio_urls;
    message.PublicDomainText = data.version_info.public_domain_text;
    if (data.version_info.text_publication_date !== "") {
      message.TextPublicationDate = data.version_info.text_publication_date;
    }
    message.ID = creating ? 0 : data.version_info.id;
    message.IsDeleted = data.version_info.is_deleted;
    message.VocalChamberMusic = data.version_info.vocal_chamber_music;


    console.log("message", message);

    setLoadingMessage("Saving song version...");
    const method = creating ? "POST" : "PUT";
    const messageUrl = `/go/api/v1/song-versions${creating ? "" : `/${message.ID}`}`;

    console.log(messageUrl);
    const sendVersionResp = await fetch(messageUrl, {
      method: method,
      body: JSON.stringify(message),
      headers: {
        "Content-type": "application/json"
      }
    });

    setSpinnerActive(false);

    if (sendVersionResp.status === 200) {
      setLoadingMessage("");
      setModalOpen(false);
    } else {
      setLoadingMessage("Error saving version");
    }

  };

  const handleTabClick = (e, target) => {
    const { name } = target;
    setActiveTab(name);
  };

  const menuItems = tabs.map((t, i) => {
    return (
      <Menu.Item name={t.name} active={activeTab === t.name} onClick={handleTabClick} key={i}>
        {t.name}
      </Menu.Item>
    )
  });

  useEffect(() => {

    //console.log("editsongversion useeffect version", version);
    
    if (version === null) {
      //console.log("setting data null");
      setData(JSON.parse(JSON.stringify(emptyVersion)));
    } else {
      const newdata = JSON.parse(JSON.stringify(version));
      Object.keys(newdata.version_info).forEach((k) => {
        if (newdata.version_info[k] === null) {
          if (k === "is_deleted") {
            newdata.version_info[k] = null;
          }else if (["audio_urls", "purchase_urls", "score_image_urls", "pdf_urls"].includes(k)) {
            newdata.version_info[k] = [];
          } else {
            newdata.version_info[k] = "";
          }
        }
      });
      if (newdata["translators"] === null) {
        newdata["translators"] = [];
      }
      setData(newdata);
    }

    const isCreating = version === null || cloning;
    setCreating(isCreating);
    let headertext = isCreating ? "Create new song version" : "Edit song version";
    setHeader(<Header as='h3' color='purple' className='subtitle'>{headertext}</Header>);


  }, [version, cloning]);

  const receiveData = (name, value) => {
    console.log("receiveData", name, value, data);
    if (name === "new_arranger_profile_id") {
      setNewArrangerProfileId(JSON.parse(value).id);
    } else if (name === "arranger_action") {
      setArrangerAction(value);
    } else if (name === "add_new_author") {
      setNewAuthorProfiles(value);
    } else if (name === "remove_author") {
      setAuthorProfileIdsToRemove(value);
    } else if (name === "add_new_translator") {
      setNewTranslatorProfiles(value)
    } else if (name === "remove_translator") {
      setTranslatorProfileIdsToRemove(value);
    } else if (name === 'ranges') {
      // maybe fill song_version_id?
      setData(old => {
        const newData = {...old};
        newData.ranges = value;
        return newData;
      })
    } else {
      const newval = {};
      newval[name] = value;
      setData((old) => {
        const new_version_info = {...old.version_info, ...newval};
        const newData = {...old};
        newData.version_info = new_version_info;
        return newData;
      });
    }
    
  }

  const editForm = <FormSongVersion 
    data={data}
    activeTab={activeTab}
    arrangerAction={arrangerAction}
    newAuthorProfiles={newAuthorProfiles}
    authorProfileIdsToRemove={authorProfileIdsToRemove}
    newTranslatorProfiles={newTranslatorProfiles}
    translatorProfileIdsToRemove={translatorProfileIdsToRemove}
    returnback={receiveData}
    instrumentMap={instrumentMap}
    vtMap={vtMap}
  />;

  return (
    <Modal size='large' trigger={openButton} open={modalOpen} onClose={() => setModalOpen(false)}
    onOpen={() => setModalOpen(true)}>
      <Modal.Header>
        {header}
      </Modal.Header>
      <Modal.Content scrolling>
        <Grid>
          <Grid.Row>
            <Grid.Column width={3}>
              <Menu vertical secondary pointing fluid>
                {menuItems}
              </Menu>
            </Grid.Column>
            <Grid.Column width={13}>
              {editForm}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Modal.Content>
      <Modal.Actions>
        <span>{loadingMessage}</span>
        <Button color='red' onClick={() => {setModalOpen(false);}} disabled={spinnerActive}>Cancel</Button>
        <Button color='green' onClick={submit} loading={spinnerActive}>Save Changes</Button>
        
      </Modal.Actions>
    </Modal>
  );
};
